
module.config(function($stateProvider, moment) {
    function makeState(name, permission, modelType) {
        $stateProvider.state('program.info.' + name, {
            url: '/' + name,
            templateUrl: 'programs/info/' + name,
            permission: permission,
            resolve: {
                history: function(ModelService, program) {
                    return ModelService.getModelRelation(program, modelType, {
                        no_page: true
                    });
                },
            },
            data: {modelType: modelType},
            controller: 'ProgramStatusController as ctrl'
        });
    }

    makeState('affiliation', 'viewAffiliation', 'affiliation_history');
    makeState('status', 'viewStatus', 'operating_history');
});


module.cC({
    name: 'ProgramStatusController',
    inject: ['$scope', '$state', 'history', 'program', 'ModelService'],
    init: function() {
        this.modelType = this.$state.current.data.modelType;
        this.unsubDelete = this.ModelService.listenFor(
            'delete', this.modelType, this._deleted);
        this.unsubCreate = this.ModelService.listenFor(
            'create', this.modelType, this._created);
    },
    on: {
        $destroy: function() {
            this.unsubCreate();
            this.unsubDelete();
        }
    },
    methods:  {
        dateGap: function(start, end) {
            return end.from(start, true);
        },
        _created: function(id, owner) {
            if (owner === this.program.id) {
                this.ModelService.debouncedGet(this.modelType, id)
                    .then(this.ModelService.appendToArray(this.history));
            }
        },
        _deleted: function(id, owner) {
            if (owner === this.program.id) {
                this.ModelService.removeById(this.modelType, id, this.history);
            }
        }
    }
})


function historyForm(ModelService, template, modelName) {
    return  {
        templateUrl: 'programs/info/' + template,
        scope: {history: '=', startAfter: '=', endBefore: '=',
                isLast: '=', program: '='},
        copyData: function(scope) {
            if (!scope.history) return {};
            return ModelService.copyFields(scope.history);
        },
        save: function(scope, data) {
            if (scope.history) {
                return ModelService.patchModel(scope.history, data);
            } else {
                return ModelService.postModelRelation(scope.program, modelName, data);
            }
        },
        delete: function(scope) {
            return ModelService.deleteModel(scope.history);
        },
        canDelete: function(scope) {
            return !!scope.history;
        },
    }
}

module.directive('affiliationHistoryForm', function(makeBasicForm, ModelService) {
    return makeBasicForm(historyForm(
            ModelService,
            'affiliationHistoryForm',
            'affiliation_history'));
});

module.directive('operatingHistoryForm', function(makeBasicForm, ModelService) {
    return makeBasicForm(historyForm(
            ModelService,
            'operatingHistoryForm',
            'operating_history'));
});
